import { defineMessages } from 'react-intl';

import { sectionDescriptionSchema } from './schema';
import SectionDescriptionEdit from './SectionDescriptionEdit';
import SectionDescriptionView from './SectionDescriptionView';

import sectionDescriptionSVG from './icons/section-description.svg';

defineMessages({
  Header: {
    id: 'Section Description',
    defaultMessage: 'Section Description',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.SectionDescriptionBlock = {
    id: 'SectionDescriptionBlock',
    title: 'Section Description',
    group: 'text',
    icon: sectionDescriptionSVG,
    view: SectionDescriptionView,
    edit: SectionDescriptionEdit,
    blockSchema: sectionDescriptionSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
